<template>
  <!-- 测一测你是哪种购物星球人 -->
  <div v-if="body_show" style="background-color: #022151;">
    <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>

    <!-- 助力详情部分 -->
    <!-- 报告 -->
    <div v-if="show_details" class="shopping-star-question" :style="{backgroundImage: 'url('+bgImg+')'}">
      <!-- <img class="bg" v-if="report.result=='R'"  src="../../../assets/ceping79/R.png" alt="" />
      <img class="bg" v-if="report.result=='I'"  src="../../../assets/ceping79/I.png" alt="" />
      <img class="bg" v-if="report.result=='A'"  src="../../../assets/ceping79/A.png" alt="" />
      <img class="bg" v-if="report.result=='S'"  src="../../../assets/ceping79/S.png" alt="" />
      <img class="bg" v-if="report.result=='E'"  src="../../../assets/ceping79/E.png" alt="" />
      <img class="bg" v-if="report.result=='C'"  src="../../../assets/ceping79/C.png" alt="" /> -->
      <!-- box -->
      <div class="box">
        <img class="top" src="@a/ceping79/que-top.png" alt="" />
        <img class="bottom" src="@a/ceping79/que-bottom.png" alt="" />
        <!--  -->
        <div class="child dq">
          <img src="@a/ceping79/p1.png" alt="">
          <h5>{{getReportTitle()[0]}}：</h5>
          <p>{{report.content[getReportTitle()[0]]}}</p>
        </div>
        <div class="child md">
          <img src="@a/ceping79/p2.png" alt="">
          <h5>潜伏目的：</h5>
          <p>{{report.content[getReportTitle()[1]]}}</p>
        </div>
        <div class="child jx">
          <img src="@a/ceping79/p3.png" alt="">
          <h5>继任优势：</h5>
          <p>{{report.content[getReportTitle()[2]]}}</p>
        </div>
        <div class="child gx">
          <img src="@a/ceping79/p4.png" alt="">
          <h5>任务贡献：</h5>
          <p>{{report.content[getReportTitle()[3]]}}</p>
        </div>
      </div>
      <!-- btn -->
      <div class="btn-group">
        <button @click="showDetailsHandle()" >返回</button>
      </div>

      <public-ad-qrcode></public-ad-qrcode>
    </div>
    <div class="details-main" v-else :style="{backgroundImage: 'url('+detailImg+')'}">
      <!-- <img class="bg"  src="../../../assets/ceping79/details-bg.png" alt="" /> -->
      <!-- user info -->
      <div @click="show_details = true" class="userinfo">
        <img :src="data.headimgurl" alt="">
        <div class="text">查看我的报告</div>
      </div>

      <!-- user info  end -->
      <h3 class="title">收集燃料回星球</h3>
      <p class="small">邀请好友送燃料助力，开启千元大奖。</p>
      <!--  -->
      <div class="box">
        <div :class="['child',item.id?'on':'',item.index && open_gift[index]?'open-g':'']" v-for="(item,index) in taUserData()" :key="index">
          <!-- 已助力显示图 -->
          <img v-if="item.id" :class="['zl',item.index && open_gift[index]?'on':'']" src="@a/ceping79/zl-on.png" alt="">
          <!-- 已打开的礼物 -->
          <img v-else-if="item.index && open_gift[index]" :class="['lw',open_gift[index]?'':'animated tada infinite']"  @click="lwHandle(index)"   src="@a/ceping79/lw-open.png" alt="">
          <!-- 未打开的礼物 -->
          <img v-else-if="item.index" class="lw animated tada infinite" @click="lwHandle(index)" src="@a/ceping79/lw.png" alt="">
          <!-- 默认好友未助力 -->
          <img v-else :class="['zl',item.index && open_gift[index]?'on':'']" src="@a/ceping79/zl.png" alt="">
          <!-- text -->
          <p v-if="item.index && item.index==1">199元门票</p>
          <p v-else-if="item.index && item.index==2">299元课程</p>
          <p class="on" v-else-if="item.index && item.index==3">500元优惠券</p>
          <!-- 未打开礼物最后一个礼物显示文字 -->
          <!-- <div  v-if="index==5"  class="open-gift3">
             <img src="@a/ceping79/open-gift3.png" alt="">
          </div> -->
         
          <!-- 好友头像 -->
          <img  v-if="item.id" class="headimg" :src="item.headimgurl" alt="">
        </div>
      </div>
      <!-- btn -->
      <div v-if="!invitationShow" class="btn-group">
        <button @click="invitationHandle()" >邀请好友</button>
      </div>
      <!--  -->
      <div class="text">
        <h4>游戏规则</h4>
        <p>1.活动时间：2020年11月2日-2020年11月11日</p>
        <p>2.邀请好友为你赠送燃料，可以获得神秘礼品</p>
        <p>3.本活动助力人群仅限新用户</p>
        <p>4.每1位好友助力，可领一个礼品。</p>
        <p>5.邀请人数越多，礼品包价值越高。</p>
        <p>6.本活动最终解释权归新精英生涯所有。</p>
      </div>

      <public-ad-qrcode></public-ad-qrcode>
    </div>
    
    <!-- 关注二维码 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt="" />
        </div>
      </div>
    </van-popup>
    <!-- 邀请助力 -->
    <van-popup class="radius on" v-model="invitationShow">
      <div class="poster">
       <img :src="data.poster" alt="">
       <div class="text">
         长按保存至相册邀请好友
       </div>
      </div>
    </van-popup>
    <!-- 弹出礼物一 -->
    <van-popup class="radius one" v-model="oneShow">
      <div class="one-box">
        <img id="img1" src="https://themes-cdn.xjy.cn/statics/career/images/ceping79/199.png" alt="">
        <button v-if="mobOrWin" :class="[mobOrWin?'on':'']"  >长按图片保存到手机</button>
        <button v-else @click="saveFileHandle('one')">保存图片</button>
      </div>
    </van-popup>
    <!-- 弹出礼物二 -->
    <van-popup class="radius one" v-model="twoShow">
      <div class="one-box">
        <img id="img2" src="https://themes-cdn.xjy.cn/statics/career/images/ceping79//299.png" alt="">
         <button v-if="mobOrWin" :class="[mobOrWin?'on':'']" >长按图片保存到手机</button>
        <button v-else @click="saveFileHandle('two')">保存图片</button>
      </div>
    </van-popup>
    <!-- 弹出礼物优惠券 -->
    <van-popup class="radius on" v-model="lwShow">
      <div class="lw">
       <img @click="toOpenGift()" src="@a/ceping79/lw-on.png" alt="">
      </div>
    </van-popup>
  </div>
</template>

<script>
import { ceping79_report } from "@/api/measurement";
import {
  queryString,
  getStorage,
  setStorage,
  deleteStorage,
  deepCopy,
  mobileOrWin
} from "@/utils/tools";
import { saveAs } from 'file-saver';
import { shareCon } from "@/utils/wxconfig";

import detailImg from '../../../assets/ceping79/details-bg.png'
import bgImg_R from '../../../assets/ceping79/R.png'
import bgImg_I from '../../../assets/ceping79/I.png'
import bgImg_A from '../../../assets/ceping79/A.png'
import bgImg_S from '../../../assets/ceping79/S.png'
import bgImg_E from '../../../assets/ceping79/E.png'
import bgImg_C from '../../../assets/ceping79/C.png'

import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";

export default {
  data() {
    return {
      type_obj: {
        evaluation_id: "",
        evaluation_name: "",
        evaluation_id: "",
        nickname: "",
      },
      data:{},
      body_show: false,
      report:{},
      isShow: false,
      qrcode: "",
      // 上一页面路由
      formPath: "",
      // 显示助力详情
      show_details:false,
      invitationShow:false,
      oneShow:false,
      twoShow:false,
      lwShow:false,
      succession:false,
      // 是否打开礼物
      open_gift:{},
      detailImg: detailImg,
      bgImg: '',
    }
  },
  components:{
    PublicAdQrcode,
    PublicTopTips,
  },
  computed: {
    mobOrWin(){
      return mobileOrWin()
    }
  },
  methods: {
    // 优惠券跳转小鹅通
    toOpenGift(){
      window.location.href = 'https://appTY2GGuUa5789.h5.xeknow.com/st/8oZbRKJc3';
    },
    // 保存图片到手机
    saveFileHandle(type){
      if(type=='one'){
        if(mobileOrWin()){
          // let x = new XMLHttpRequest();
          // x.open("GET", document.getElementById('img1').src, true);
          // x.responseType = 'blob';
          // x.onload=function(e){
          //     var url = window.URL.createObjectURL(x.response)
          //     var a = document.createElement('a');
          //     a.href = url
          //     a.download = '199元直播门票'
          //     a.click()
          // }
          // x.send();
          let link = document.getElementById('img1').src;
          let savename;
          let arr = link.split('/');
            let basename = arr[arr.length - 1];
            let info = basename.split('.');
            let ext = info.length > 1 ? info[info.length - 1] : 'jpg';

            if(!savename) {
                savename = basename;
            } else if (savename.indexOf('.') < 0) {
                savename = savename + '.' + ext;
            }
            saveAs(link, savename);
          this.$toast('保存成功！');

          // let a = document.createElement('a')
          // a.download ='199元直播门票'
          // // 设置图片地址
          // a.href = document.getElementById('img1').src;
          // a.click();
        }else{
          saveAs(document.getElementById('img1').src, '199元直播门票');
          this.$toast('保存成功！');
        }
        
      }else{
        if(mobileOrWin()){
          let x = new XMLHttpRequest();
          x.open("GET", document.getElementById('img2').src, true);
          x.responseType = 'blob';
          x.onload=function(e){
              var url = window.URL.createObjectURL(x.response)
              var a = document.createElement('a');
              a.href = url
              a.download = '299线上课程'
              a.click()
          }
          x.send();
          this.$toast('保存成功！');
          // let a = document.createElement('a')
          // a.download ='199元直播门票'
          // // 设置图片地址
          // a.href = document.getElementById('img2').src;
          // a.click();
        }else{
          saveAs(document.getElementById('img2').src, '299线上课程');
          this.$toast('保存成功！');
        }
      }
    },
    // 获取报告信息标题
    getReportTitle(){
      let arr = Object.keys(this.report.content);
      return arr?arr:['地球身份','目的','竞选优势','购物星球领袖任务贡献'];
    },
    // 设置助力用户数据
    taUserData(){
      let len_ = 3-this.data.support_list.length;
      let arr = [];
      let len_index = 0;
      let idx_ = 0;
      for(let i=0;i<6;i++){
        // 判断是奇偶
        if(i%2==0){
          arr.push(this.data.support_list[len_index]?this.data.support_list[len_index]:{});
          len_index+=1;
        }else{
          idx_+=1;
          arr.push({
            index:idx_
          });
        }
      }
      return arr
    },
    // 判断是否完成用户邀请
    lwHandle(idx){
      if(idx==5){
        if(this.data.support_list.length<3){
          this.$toast('好友助力需要达到3位才可以解锁哦~');
          return
        }
        this.open_gift[idx] =  true;
        setStorage(this.$route.path,'open_gift',this.open_gift);
        this.lwShow = true;
      }else if(idx==1){
        if(this.data.support_list.length==0){
          this.$toast('需要1位朋友助力哦~');
          return
        }
        this.open_gift[idx] =  true;
        setStorage(this.$route.path,'open_gift',this.open_gift);
        this.oneShow = true
      }else if(idx==3){
        if(this.data.support_list.length<2){
          this.$toast('好友助力需要达到2位才可以解锁哦~');
          return
        }
        this.open_gift[idx] =  true;
        setStorage(this.$route.path,'open_gift',this.open_gift);
        this.twoShow = true
      }
    },
    // 邀请好友
    invitationHandle(){
      this.invitationShow = true;
    },
    // 显示助力详情
    showDetailsHandle(){
      setStorage(this.$route.path,'succession',1);
      this.succession  = true;
      this.show_details = false;
    },
    // 转换选项数据格式
    strToArr(str) {
      if (!str) {
        return [];
      }
      return str.split(";");
    },
    // 初始化数据
    pullData() {
      //调用加载中
      this.$emit("loadingHandle", true, "拼命加载中...");
      let q = this.$route.query;

      ceping79_report().then((data) => {
        if (data.code != "10002") {
          document.title = data.headtitle;
          this.body_show = true;
          this.data = data;
          this.report = data.report;
          switch(data.report.result) {
            case 'R':
              this.bgImg = bgImg_R;
              break;
            case 'I':
              this.bgImg = bgImg_I;
              break;
            case 'A':
              this.bgImg = bgImg_A;
              break;
            case 'S':
              this.bgImg = bgImg_S;
              break;
            case 'E':
              this.bgImg = bgImg_E;
              break;
            case 'C':
              this.bgImg = bgImg_C;
              break;
          }
          this.qrcode = data.qrcode;
          if (this.data.need_subscribe && !this.data.subscribe) {
            this.isShow = true;
          }
          // this.succession = getStorage(this.$route.path,'succession');
          this.show_details = false;

          // 是否打开过礼物
          if(getStorage(this.$route.path,'open_gift')){
            this.open_gift = getStorage(this.$route.path,'open_gift');
          }


          // 给wxconfig传对象
          this.type_obj.nickname = data.nickname;
          this.type_obj.evaluation_id = data.cid;
          this.type_obj.evaluation_name = data.headtitle;
          this.type_obj.evaluation_user_id = String(data.uid);
          this.type_obj.path = this.$route.path;

          shareCon("ceping79", this, this.type_obj);
        } else {
          // 测评未完成
          this.$router.push("/ceping79");
        }

        //关闭加载中
        this.$emit("loadingHandle", false);
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      //  这里的vm指的就是vue实例，可以用来当做this使用
      vm.formPath = from.path;
    });
  },
  created() {
    this.pullData();
  },
};
</script>

<style lang="scss" scoped>
/* 设置持续时间和动画函数 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
  opacity: 0;
}
.details-main{
  text-align: center;
  padding-top: 166px;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;

  img.bg {
    position: absolute;
    width: 100%;
    max-width: 750px;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    z-index: -1;
  }
  .userinfo{
    position: absolute;
    right: 20px;
    top: 20px;
    img{
      width: 54px;
      height: 54px;
      border-radius: 50%;
      margin-bottom: 10px;
    }
    .text{
      color: #ffffff;
      font-size: 20px;
    }
  }
  h3.title{
    text-align: center;
    margin-bottom: 30px;
    font-size: 60px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 1;
  }
  p.small{
    text-align: center;
    line-height: 1;
    font-size: 24px;
    color: #ffffff;
    margin-bottom: 84px;
  }
  .box{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0px 72px;
    .child.on{
      margin-top: 0;
      .zl{
        width: 185px;
        height: auto;
        margin-bottom: 50px;
      }
      .zl.on{
        margin-top: 25px;
      }
      .lw{
        width: 195px;
        margin-right: -20px;
        margin-top: 25px;
        margin-bottom: 50px;
      }
      .headimg{
        position: absolute;
        width: 54px;
        height: 54px;
        right: 30px;
        top: 90px;
        border-radius: 50%;
        border: 2px solid #FFFFFF;
      }
    }
    .child.open-g{
      padding-right: 30px;
      margin-top: 0;
    }
    .child{
      width: 33.33%;
      position: relative;
      margin-top: 20px;
      .zl{
        width: 120px;
        height: 120px;
      }
      .zl.on{
        margin-top: 25px;
      }
      .lw{
        width: 195px;
        margin-right: -20px;
      }
      
      .headimg{
        position: absolute;
        width: 54px;
        height: 54px;
        right: 30px;
        top: 65px;
        border-radius: 50%;
        border: 2px solid #FFFFFF;
      }
      p{
        position: relative;
        font-size: 24px;
        color: #FFFFFF;
        margin-top: -20px;
        z-index: 2;
      }
      p.on{
        font-size: 24px;
        color:#FDD867;
      }
      .open-gift3{
        position: absolute;
        width: 194px;
        height: 38px;
        top: -50px;
        left: 5px;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .btn-group {
    display: flex;
    margin: 30px auto 60px;
    justify-content: center;
    button {
      width: 600px;
      height: 80px;
      line-height: 80px;
      background: linear-gradient(0deg, #b2f4ff 0%, #25cafe 100%);
      border-radius: 20px;
      border: none;
      color: #ffffff;
      font-size: 36px;
      font-weight: bold;
      text-shadow: 0px 4px 4px rgba(0, 181, 236, 0.31);
      letter-spacing: 4px;
    }
  }
  .text{
    text-align: center;
    h4{
      font-size: 32px;
      font-weight: bold;
      color: #ffffff;
      line-height: 1;
      margin-bottom: 35px;
    }
    p{
      font-size: 24px;
      color: #ffffff;
      line-height: 48px;
      text-align: left;
      margin-left: 141px;
      width: 510px;
    }
  }
}
// 报告部分
.shopping-star-question {
  text-align: center;
  padding-top: 270px;
  overflow-x: hidden;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 100%;

  img.bg {
    position: absolute;
    width: 100%;
    max-width: 750px;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    z-index: -1;
  }
  .box {
    margin: 0 auto;
    width: 690px;
    padding: 40px 74px 40px;
    background: #ffffff;
    box-shadow: 0px 4px 4px 0px rgba(0, 14, 39, 0.31);
    border-radius: 20px;
    position: relative;
    .top {
      position: absolute;
      right: -40px;
      width: 125px;
      top: -40px;
    }
    .bottom {
      height: 143px;
      position: absolute;
      right: -120px;
      bottom: -55px;
    }
    .child.dq img{
      width: 90px;
    }
    .child.md img{
      width: 50px;
    }
    .child.jx img{
      width: 56px;
    }
    .child.gx img{
      width: 94px;
    }
    .child{
      margin-bottom: 40px;
      text-align: center;
      &:last-child{
        margin-bottom: 0;
      }
      h5{
        font-size: 32px;
        color: #25CBFE;
        line-height: 1;
        margin-bottom: 20px;
      }
      p{
        font-size: 28px;
        color: #333333;
        line-height: 36px;
      }
    }
  }
  .btn-group {
    display: flex;
    margin: 70px auto 48px;
    justify-content: center;
    button {
      width: 300px;
      height: 80px;
      line-height: 80px;
      background: linear-gradient(0deg, #b2f4ff 0%, #25cafe 100%);
      border-radius: 20px;
      border: none;
      color: #ffffff;
      font-size: 38px;
      font-weight: bold;
      text-shadow: 0px 4px 4px rgba(0, 181, 236, 0.31);
      &:first-child {
        margin-right: 30px;
      }
    }
  }
}





.mt32 {
  margin-top: 32px;
}

.pt32 {
  padding-top: 32px;
}

.pb-public {
  padding: changeRem(0.425) + px;
}

.pop {
  img {
    max-width: 8rem;
  }
}
.radius.on{
  background-color: transparent;
  .lw img{
    width: 616px;
  }
}
.radius.one{
  background-color: transparent;
  .one-box{
    position: relative;
    text-align: center;
    img{
      width: 590px;
      z-index: -1;
    }
    button{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 60px;
      width: 382px;
      height: 80px;
      background: linear-gradient(0deg, #C0F2FD 0%, #60C8F9 100%);
      border-radius: 20px;
      border: none;
      font-size: 38px;
      color: #FFFFFF;
      line-height: 58px;
      text-shadow: 0px 4px 4px rgba(79, 179, 231, 0.31);
    }
    button.on{
      width: 400px;
    }
  }
}
.radius {
  border-radius: 10px;
  .poster{
    background: transparent;
    img{
      width: 580px;
    }
    .text{
      width: 300px;
      text-align: center;
      padding: 15px 16px;
      // border: 1px solid #FFFFFF;
      border-radius: 10px;
      color: #ffffff;
      font-size: 24px;
      margin: 60px auto 0px;
    }
  }
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #f57f17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}

</style>